import types from '../types/deposit'

export default class remove {

  static setOpen(isOpen) {
    return {
      type: types.SET_OPEN,
      payload: {
        isOpen,
      },
    }
  }

  static start() {
    window.location.href = process.env.REACT_APP_LANDING_URL + "?open=c"
    return {
      type: types.START,
    }
  }

  static setFlowStep(flowStep) {
    return {
      type: types.SET_FLOW_STEP,
      payload: {
        flowStep,
      },
    }
  }

  static setFlowReset(flowReset) {
    return {
      type: types.SET_FLOW_RESET,
      payload: {
        flowReset,
      },
    }
  }

  static setFlowLoading(flowLoading) {
    return {
      type: types.SET_FLOW_LOADING,
      payload: {
        flowLoading,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/depositV2/actions/deposit.js